import { statusColors } from "../../../theme/statusPalette";

export interface QuotationStatusStyle {
  soft: string;
  mid: string;
  solid: string;
  text: string;
}

export const getQuotationStatusStyle = (status?: string | null): QuotationStatusStyle => {
  switch (status?.toUpperCase()) {
    case "CREATED":
      return {
        soft: statusColors["brilliant-rose"][100],
        mid: statusColors["brilliant-rose"][400],
        solid: statusColors["brilliant-rose"][500],
        text: statusColors["brilliant-rose"][800],
      };
    case "SENT":
      return {
        soft: statusColors["blue-chronoflex"][100],
        mid: statusColors["blue-chronoflex"][400],
        solid: statusColors["blue-chronoflex"][500],
        text: statusColors["blue-chronoflex"][800],
      };
    case "ACCEPTED":
      return {
        soft: statusColors.eden[100],
        mid: statusColors.eden[400],
        solid: statusColors.eden[500],
        text: statusColors.eden[800],
      };
    case "DONE":
      return {
        soft: statusColors["pastel-green"][100],
        mid: statusColors["pastel-green"][400],
        solid: statusColors["pastel-green"][500],
        text: statusColors["pastel-green"][800],
      };
    case "AWAITING":
      return {
        soft: statusColors.yellow[100],
        mid: statusColors.yellow[400],
        solid: statusColors.yellow[500],
        text: statusColors.yellow[800],
      };
    default:
      return {
        soft: statusColors["chrono-gray"][100],
        mid: statusColors["chrono-gray"][400],
        solid: statusColors["chrono-gray"][500],
        text: statusColors["chrono-gray"][800],
      };
  }
};
